import { supabase } from '@/lib/supabase'

import {
  defaultSignalsOverlayLevels,
  type SignalsOverlayLevelKey,
  type SignalsOverlayLevels,
} from '@/modules/signals/utils/signalsOverlayLevels'

export type { SignalsOverlayLevelKey, SignalsOverlayLevels }

const KEYS: Record<SignalsOverlayLevelKey, string> = {
  entryInitial: 'chart.signals.overlay.entry_initial.enabled',
  entryMid: 'chart.signals.overlay.entry_mid.enabled',
  entryFinal: 'chart.signals.overlay.entry_final.enabled',
  stop: 'chart.signals.overlay.stop.enabled',
  targets: 'chart.signals.overlay.targets.enabled',
}

export async function getSignalsOverlayLevels(): Promise<SignalsOverlayLevels> {
  const keys = Object.values(KEYS)
  const { data, error } = await supabase.from('app_settings').select('key,value').in('key', keys)
  if (error) throw error

  const map = new Map<string, string>()
  for (const r of (data || [])) {
    map.set(String((r as any).key), String((r as any).value ?? ''))
  }

  const readBool = (k: string): boolean => {
    const v = map.get(k)
    if (v == null || v === '') return true
    return String(v) === 'true'
  }

  return {
    entryInitial: readBool(KEYS.entryInitial),
    entryMid: readBool(KEYS.entryMid),
    entryFinal: readBool(KEYS.entryFinal),
    stop: readBool(KEYS.stop),
    targets: readBool(KEYS.targets),
  }
}

export async function setSignalsOverlayLevel(key: SignalsOverlayLevelKey, on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEYS[key], value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

export async function setSignalsOverlayLevels(values: Partial<SignalsOverlayLevels>): Promise<void> {
  const rows: Array<{ key: string; value: string }> = []
  for (const k of Object.keys(values) as SignalsOverlayLevelKey[]) {
    const v = (values as any)[k]
    if (typeof v !== 'boolean') continue
    rows.push({ key: KEYS[k], value: v ? 'true' : 'false' })
  }
  if (rows.length === 0) return
  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}
export { defaultSignalsOverlayLevels }
